import { parseISO, formatISO, getHours, addHours, differenceInHours, setMinutes } from 'date-fns';
import { ShipmentStopsGridData } from '@pages/reporting-pages/shipment-stops/types/ShipmentStopsGridData';
import { isMinDate } from 'components/global/utils';
import { TimelineLimitTimes } from '@pages/reporting-pages/shipment-stops/types/TimelineLimitTimes';
import { compareAsc, isSameDay } from "date-fns";
import { HoursArrayElement } from '@pages/reporting-pages/shipment-stops/types/HoursArrayElement';



export function createHoursArray(beginDate: string | null, hoursLength: number, selectedDate: string | null): HoursArrayElement[] {
	let hoursArray: HoursArrayElement[] = [];
	let parsedBeginDate = beginDate ? parseISO(beginDate) : null;
	let parsedSelectedDate = selectedDate ? parseISO(selectedDate) : null;
	if (!parsedBeginDate) return hoursArray;

	for (let index = 0; index < hoursLength; index++) {
		let shiftedDate = addHours(parsedBeginDate, index);
		hoursArray.push({
			hourNumber: String(getHours(shiftedDate)),
			isSelectedDate: parsedSelectedDate ? isSameDay(shiftedDate, parsedSelectedDate) : true,
		})
	}

	return hoursArray;
}



export function getGridTemplateColumns(beginDate: string | null, hoursLength: number): string {
	let hoursArray: string[] = [];
	let beginHour = beginDate ? getHours(parseISO(beginDate)) : 0;

	for (let index = 1; index <= hoursLength; index++) {
		hoursArray.push('1fr');
		beginHour++;
	}

	return hoursArray.join(' ');;
}



export const getTimelineLimitTimes = (gridData: ShipmentStopsGridData[] | null) => {

	let limitTimes: TimelineLimitTimes = { maxDeparture: null, minArrival: null, hoursLength: 0 };

	const computedLimitTimes = gridData ? gridData.reduce((acc, data, index, array) => {

		let maxDeparture =
			isMinDate(data.plannedDeparture) && isMinDate(data.realDeparture)
			? null
			: !isMinDate(data.plannedDeparture) && isMinDate(data.realDeparture)
			? data.plannedDeparture
			: isMinDate(data.plannedDeparture) && !isMinDate(data.realDeparture)
			? data.realDeparture
			: compareAsc(data.plannedDeparture, data.realDeparture) === 1
			? data.plannedDeparture
			: data.realDeparture;

		if (maxDeparture !== null) {
			if (acc.maxDeparture === null || maxDeparture > acc.maxDeparture) {
				acc.maxDeparture = maxDeparture;
			}
		}

		let minArrival =
			isMinDate(data.realArrival) && isMinDate(data.plannedArrival)
			? null
			: !isMinDate(data.realArrival) && isMinDate(data.plannedArrival)
			? data.realArrival
			: isMinDate(data.realArrival) && !isMinDate(data.plannedArrival)
			? data.plannedArrival
			: compareAsc(data.realArrival, data.plannedArrival) === -1
			? data.realArrival
			: data.plannedArrival;
		
		if (minArrival !== null) {
			if (acc.minArrival === null || minArrival < acc.minArrival) {
				acc.minArrival = minArrival;
			}
		}

		// when last element loop, round dates and calculate hours length
		if (index === array.length - 1 && acc.minArrival && acc.maxDeparture) {
			let maxDepartureDate = parseISO(acc.maxDeparture);
			let maxDepartureDateRounded = setMinutes(maxDepartureDate, 0);
			let maxDepartureExtendDate = addHours(maxDepartureDateRounded, 1);

			let minArrivalDate = parseISO(acc.minArrival);
			let minArrivalDateRounded = setMinutes(minArrivalDate, 0);
			
			acc.maxDeparture = formatISO(maxDepartureExtendDate);
			acc.minArrival = formatISO(minArrivalDateRounded);
			acc.hoursLength = differenceInHours(maxDepartureExtendDate, minArrivalDateRounded) + 1;

			if (acc.hoursLength > 0 && acc.hoursLength < 4) {
				const adjustments = {
					1: { minAdjust: -1, maxAdjust: 2 },
					2: { minAdjust: -1, maxAdjust: 1 },
					3: { minAdjust: 0, maxAdjust: 1 }
				};

				const { minAdjust, maxAdjust } = isValidHoursLength(acc.hoursLength)
					? adjustments[acc.hoursLength]
					: { minAdjust: 0, maxAdjust: 0 };

				if (minAdjust !== undefined && maxAdjust !== undefined) {
					acc.minArrival = formatISO(addHours(minArrivalDateRounded, minAdjust));
					acc.maxDeparture = formatISO(addHours(maxDepartureExtendDate, maxAdjust));
					acc.hoursLength = 4;
				}
			}
		}
		return acc;
	}, limitTimes) : limitTimes;

	return computedLimitTimes;
}



function isValidHoursLength(value: number): value is 1 | 2 | 3 {
	return value === 1 || value === 2 || value === 3;
}